











































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {
    ConfigScheduleCalcMap,
    SelectBox,
    TaskInfoCalc
} from '@/interfaces/global-data';
import {
    ScheduleCalcColumns,
    ScheduleCalcFilter,
    ScheduleIndividualConfigs,
    SchedulePeriods,
    SmallSalesReportsScheduleListFilter,
    UserRole,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import KviCartSelect from "@/components/KviCartSelect.vue";
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {ISaleOptionsForSelectBox, ISaleResponseDto, IidAndName, ILabelAndValue} from "@/pages/Sales/data";
import SalesApi from "@/pages/Sales/SalesApi";
import {isNull} from "lodash";

interface ITableFilterValues {
    sales: number[],
    startDate: string | null,
    endDate: string | null,
    groups: number[],
    categories: number[],
    subcategories: number[],
    storeFormat: number | null,
    storeRegions: number[],
    storeClusters: number[],
}

@Component({
    computed: {
        moment() {
            return moment;
        }
    },
    components: {
        KviCartSelect,
        MarketSelect,
        MultiSelect,
        vSelect,
        DatePicker,
        CollapseCard,
        Card,
        CSelect,
        SwitchWithLabel
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
    },
})
export default class ReportsSchedule extends Mixins(LocalData, Toast, Http) {
    @Prop({required: true}) readonly saleFromList: ISaleResponseDto = {} as ISaleResponseDto;
    @Prop({required: true}) readonly activeTabKey: string = '' as string;

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};

    selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectFormatFilter: number = this.defaultFilterValue.value;

    selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectRegionFilter: number = this.defaultFilterValue.value;

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    kviCartComponentKey = 1;
    searchable: boolean = true;
    selectSchedulePeriod: SelectBox<SchedulePeriods> = {value: SchedulePeriods.NO_REPEAT, label: this.$t('shared.reportsSchedule.noRepeat') as string};

    scheduleListTableData: ScheduleCalcColumns[] = [];

    schedulePriority: number = 1;
    scheduleTimeout: number = 24;

    private api: SalesApi = new SalesApi({parent: this})

    private saleIdForPage: number = -1;

    defaultSelectSaleOptions: any = [{
        value: -1,
        label: this.$t('shared.parametersTab.notSelected') as string,
        disabled: true,
    }];
    selectSaleOptions: any = [...this.defaultSelectSaleOptions];

    isSalesForSelectLoading: boolean = false;

    salePageSelected: any = {
        id: -1,
        name: this.$t('shared.selectBox.all') as string,
        tradingId: null,
        groups: [],
        categories: [],
        subcategory: null,
        format: null,
        regions: [],
        clusters: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        status: null,
    };

    parametersObj: any = {
        calculationDay: 28,
        revaluationCalculateParams: {
            calculateByAllCompetitors: true,
            useRevaluationCalculate: false,
            purchasePriceDelta: 15,
            competitorsPriceDelta: 15,
            revaluationFrequencyCalculationDepth: 7,
            revaluationNumber: 1,
        },
        isFixPricePromo: false,
        applyOmnichannel: false,
        sendReportToFtp: false,
        selectCoefficent: {value: {k1: 1, k2: 0}, label: this.$t('shared.parametersTab.maxGrossMargin') as string},
        thompsonSampling: false,
        compensateLowerTargets: false,
        backBasketPart: 80.0,
        compensateAllCategories: false,
    };

    scheduleListTableColumns: any = [
        {dataIndex: 'id', title: this.$t('shared.labels.actions') as string, scopedSlots: { customRender: 'options' }, fixed: 'left', width: 130},
        {
            dataIndex: 'sale.name',
            title: this.$t('shared.reportsSchedule.sale') as string,
            showSearch: true,
            filterModelKey: 'sales',
            filterOptionsKey: 'saleOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
        },
        {
            dataIndex: 'startDate',
            title: this.$t('shared.reportsSchedule.startDate') as string,
            filterModelKey: 'startDate',
            scopedSlots: {
                scopedSlots: { customRender: 'startDate' },
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon",
            },
            width: 170,
        },
        {
            dataIndex: 'endDate',
            title: this.$t('shared.reportsSchedule.endDate') as string,
            filterModelKey: 'endDate',
            scopedSlots: {
                scopedSlots: { customRender: 'endDate' },
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon",
            },
            width: 170,
        },
        {dataIndex: 'schedulePeriod', title: this.$t('shared.reportsSchedule.periodicity') as string, scopedSlots: { customRender: 'schedulePeriod' }, width: 150},
        {dataIndex: 'priority', title: this.$t('shared.reportsSchedule.priority') as string, scopedSlots: { customRender: 'priority' }, width: 150},
        {dataIndex: 'timeout', title: this.$t('shared.reportsSchedule.timeout') as string, scopedSlots: { customRender: 'timeout' }, width: 150},
        {dataIndex: 'tradingName', title: this.$t('shared.reportsSchedule.company') as string, width: 200},
        {dataIndex: 'saleStageNumber', title: this.$t('shared.reportsSchedule.saleStage') as string, width: 150},
        {dataIndex: 'remainingStagesCount', title: this.$t('shared.reportsSchedule.stagesToCalc') as string, width: 200},
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('shared.reportsSchedule.group') as string,
            filterModelKey: 'groups',
            filterOptionsKey: 'groupOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'categories',
            title: this.$t('shared.reportsSchedule.category') as string,
            filterModelKey: 'categories',
            filterOptionsKey: 'categoryOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.reportsSchedule.subcategory') as string,
            filterModelKey: 'subcategories',
            filterOptionsKey: 'subcategoryOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.filters.format') as string,
            filterModelKey: 'storeFormat',
            filterOptionsKey: 'storeFormatOptions',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'storeRegionValues',
            title: this.$t('shared.filters.region') as string,
            filterModelKey: 'storeRegions',
            filterOptionsKey: 'storeRegionOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.filters.cluster') as string,
            filterModelKey: 'storeClusters',
            filterOptionsKey: 'storeClusterOptions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
    ];

    pagination: any = {
        current: 1,
        pageSize: 20,
        total: 0,
    };

    tableFilterOptions: any = {};
    tableFilterSearchText: any = {
        sales: '',
    };
    tableFilterValues: ITableFilterValues = {
        sales: [],
        startDate: null,
        endDate: null,
        groups: [],
        categories: [],
        subcategories: [],
        storeFormat: null,
        storeRegions: [],
        storeClusters: [],
    };

    isTableLoading: boolean = false;
    isSaveScheduleBtnLoading: boolean = false;

    schedulePeriodOptions: Array<SelectBox<SchedulePeriods>> = [
        {value: SchedulePeriods.NO_REPEAT, label: this.$t('shared.reportsSchedule.noRepeat') as string},
        {value: SchedulePeriods.DAY, label: this.$t('shared.reportsSchedule.daily') as string},
        {value: SchedulePeriods.WEEK, label: this.$t('shared.reportsSchedule.weekly') as string},
        {value: SchedulePeriods.MONTH, label: this.$t('shared.reportsSchedule.monthly') as string},
    ];

    scheduleCalcTotalRows: number = 0;
    calcWithScheduleCrossForModal: boolean = false;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    private dropDownOpen = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
    private individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs> = {};
    private isScheduleCross: boolean = false;
    private responseId: number = -1;
    private needLoadFiltersForTable: boolean = true;
    private scheduleCalcId: number = -1;
    private startScheduleDate: string | null = null;
    private endScheduleDate: string | null = null;
    private scheduleCalcLimit: number = 20;

    @Watch('activeTabKey')
    onActiveTabKeyChanged(value: string) {
        if (value === 'reportsScheduleSubTab') {
            if (this.selectSaleOptions.length < 2) {
                // далее - временно, получение списка всех распродаж легковесных - здесь будет запрос на бэк
                this.fetchSalesForSelect().then(() => {
                    if (this.saleIdForPage !== this.saleFromList.id && !(this.saleFromList.id === null && this.saleIdForPage === -1)) {
                        this.saleIdForPage = !isNull(this.saleFromList.id) ? this.saleFromList.id : -1;
                    }
                }).catch(() => {});
            } else {
                if (this.saleIdForPage !== this.saleFromList.id && !(this.saleFromList.id === null && this.saleIdForPage === -1)) {
                    this.saleIdForPage = !isNull(this.saleFromList.id) ? this.saleFromList.id : -1;
                }
            }
        }
    }

    @Watch('saleIdForPage')
    async onSaleIdForPageChanged(value: number) {
        this.handleSalePageSelectedChanged();

        if (value !== -1 && !isNull(value)) {
            // далее - временно, получение маски распродажи - здесь будет запрос на бэк
            const sale = this.selectSaleOptions.find((saleObj: any) => saleObj.value === value);

            if (sale) {
                this.salePageSelected = {
                    id: sale.value,
                    name: sale.label,
                    tradingId: sale.tradingId,
                    groups: sale.groups,
                    categories: sale.categories,
                    subcategory: sale.subcategory,
                    format: sale.format,
                    regions: sale.regions,
                    clusters: sale.clusters,
                    minSaleDiscount: sale.minSaleDiscount,
                    maxSaleDiscount: sale.maxSaleDiscount,
                    status: sale.status,
                }
            } else {
                await this.fetchSalesForSelect();

                const saleAfterFetch = this.selectSaleOptions.find((saleObj: any) => saleObj.value === value);

                if (saleAfterFetch) {
                    this.salePageSelected = {
                        id: saleAfterFetch.value,
                        name: saleAfterFetch.label,
                        tradingId: saleAfterFetch.tradingId,
                        groups: saleAfterFetch.groups,
                        categories: saleAfterFetch.categories,
                        subcategory: saleAfterFetch.subcategory,
                        format: saleAfterFetch.format,
                        regions: saleAfterFetch.regions,
                        clusters: saleAfterFetch.clusters,
                        minSaleDiscount: saleAfterFetch.minSaleDiscount,
                        maxSaleDiscount: saleAfterFetch.maxSaleDiscount,
                        status: sale.status,
                    }
                }
            }
            // конец кода, который должен будет заменён
        } else {
            this.salePageSelected = this.defaultSelectSaleOptions[0];
            this.scheduleListTableData = [];
            this.pagination.current = 1;
            this.pagination.total = 0;
        }
    }

    get saveScheduleBtnProps(): {
        disabled: boolean;
        tip: string;
    } {
        const isBtnDisabled: boolean = this.salePageSelected.id === -1 || !this.startScheduleDate || !this.endScheduleDate
            || !this.schedulePriority || !this.scheduleTimeout;

        return {
            disabled: isBtnDisabled,
            tip: (() => {
                if (!isBtnDisabled) {
                    return '';
                } else {
                    if (this.salePageSelected.id === -1) {
                        return this.$t('shared.reportsSchedule.selectSaleRequired') as string;
                    } else {
                        return this.$t('shared.reportsSchedule.fillAllFields') as string;
                    }
                }
            })(),
        }
    }

    mounted() {
        if (this.$sales.selectMarket.id !== -1) {
            this.fetchSalesForSelect();

            this.needLoadFiltersForTable = true;
            this.fetchScheduleCalcList();
        }
    }

    handleFilter() {
        this.fetchScheduleCalcList();
    }

    handleClearFilters() {
        this.resetFiltersData();

        this.needLoadFiltersForTable = true;
        this.fetchScheduleCalcList();
    }

    resetFiltersData() {
        this.tableFilterValues = {
            sales: [],
            startDate: null,
            endDate: null,
            groups: [],
            categories: [],
            subcategories: [],
            storeFormat: null,
            storeRegions: [],
            storeClusters: [],
        };
        this.tableFilterOptions = {};
    }

    onScheduleCalcTableChange(pagination: any) {
        this.pagination.current = pagination.current;

        this.fetchScheduleCalcList();
    }

    selectData(): [number[], number[], number[], number[], number | null] {
        const formatIds = [this.salePageSelected.format.id];
        const regionIds = this.salePageSelected.regions.map((el: IidAndName) => el.id);
        const clusterIds = this.salePageSelected.clusters.map((el: IidAndName) => el.id);
        const categoryIds = this.salePageSelected.categories.map((el: IidAndName) => el.id);
        const subcategory = this.salePageSelected.subcategory ? this.salePageSelected.subcategory.id : null;

        const selectRegions: number[] = (!regionIds.length || (regionIds.length && regionIds[0] === -1)) ? [] : LocalData.filterNumberArrays(regionIds)!!;
        const selectFormats: number[] = (!formatIds.length || (formatIds.length && formatIds[0] === -1)) ? [] : LocalData.filterNumberArrays(formatIds)!!;
        const selectClusters: number[] = (!clusterIds.length || (clusterIds.length && clusterIds[0] === -1)) ? [] : LocalData.filterNumberArrays(clusterIds)!!;
        const categories: number[] = (!categoryIds.length || (categoryIds.length && categoryIds[0] === -1)) ? [] : LocalData.filterNumberArrays(categoryIds)!!;

        return [selectRegions, selectFormats, selectClusters, categories, subcategory];
    }

    saveEditableSchedule(id: number) {
        if (this.individualScheduleParams[id] === undefined) {
            this.individualScheduleParams[id] = {};
        }

        const config = this.individualScheduleParams[id];

        this.httpSaveScheduleIndividualCalc(config, id)
            .then(() => {
                    this.showInfo(this.$t('shared.reportsSchedule.scheduleParamsSaved') as string);

                    this.fetchScheduleCalcList();
                },
            )
            .catch(() => {
                this.showError(this.$t('shared.reportsSchedule.errorSaveScheduleParams') as string);
            });
    }

    deleteSchedule(scheduleId: number) {
        this.httpDeleteScheduleCalc(scheduleId)
            .then((r) => {
                    this.showInfo(this.$t('shared.reportsSchedule.scheduleDeleted') as string);

                    this.resetFiltersData();
                    this.needLoadFiltersForTable = true;

                    this.fetchScheduleCalcList();
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.reportsSchedule.errorDeleteCalcSchedule') as string);
            });
    }

    setSchedulePeriodIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, selectedPeriod: string) {
        if (typeof individualScheduleParams[id] === 'undefined') {
            individualScheduleParams[id] = {}
        }
        individualScheduleParams[id][property] = selectedPeriod
    }

    setScheduleDateIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, date: string) {
        if (typeof individualScheduleParams[id] === 'undefined') {
            individualScheduleParams[id] = {}
        }
        individualScheduleParams[id][property] = date
    }

    setScheduleTimeoutOrPriorityIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, timeoutOrPriority: number) {
        if (typeof individualScheduleParams[id] === 'undefined') {
            individualScheduleParams[id] = {}
        }
        individualScheduleParams[id][property] = timeoutOrPriority
    }

    saveSchedule() {
        if (this.$sales.selectMarket.id === -1) {
            this.showError(this.$t('shared.reportsSchedule.tradingCompanyNotSelected') as string);
            return;
        }

        const scheduleParams = this.getCalcScheduleFilter();

        this.isSaveScheduleBtnLoading = true;

        this.httpIdenticalCheckScheduleCalc(scheduleParams)
            .then((r) => {
                    if (r.data > 0) {
                        this.showAction(
                            this.$t('shared.reportsSchedule.scheduleExistsOverwrite') as string,
                            {
                                position: 'top-center',
                                type: 'info',
                                singleton: true,
                                duration: 10000,
                                icon: 'check',
                                theme: 'bubble',
                                action: [{
                                    text: this.$t('shared.labels.yes') as string,
                                    onClick: () => {
                                        this.scheduleCalcId = r.data
                                        this.isScheduleCross = false
                                        this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
                                            .then((response) => {
                                                    this.showInfo(this.$t('shared.reportsSchedule.scheduleSaved') as string);
                                                    this.resetFiltersData();
                                                    this.needLoadFiltersForTable = true;

                                                    this.fetchScheduleCalcList();
                                                },
                                            )
                                            .catch((ex) => {
                                                this.showError(this.$t('shared.reportsSchedule.errorSaveCalcSchedule') as string);
                                            });
                                    },
                                }],
                            });
                    } else {
                        this.httpCrossCheckScheduleCalc(scheduleParams)
                            .then((resp) => {
                                    if (resp.data > 0) {
                                        this.responseId = resp.data
                                        this.calcWithScheduleCrossForModal = true
                                    } else {
                                        this.scheduleCalcId = resp.data
                                        this.isScheduleCross = true
                                        this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
                                            .then((response) => {
                                                    this.showInfo(this.$t('shared.reportsSchedule.scheduleSaved') as string);
                                                    this.resetFiltersData();
                                                    this.needLoadFiltersForTable = true;

                                                    this.fetchScheduleCalcList();
                                                },
                                            )
                                            .catch((ex) => {
                                                this.showError(this.$t('shared.reportsSchedule.errorSaveCalcSchedule') as string);
                                            });
                                    }
                                },
                            )
                            .catch((e) => {
                                this.showError(this.$t('shared.reportsSchedule.errorSaveCalcSchedule') as string);
                            });
                    }
                },
            ).finally(() => {
                this.isSaveScheduleBtnLoading = false;
            });
    }

    saveCrossSchedule() {
        const scheduleParams = this.getCalcScheduleFilter();
        this.scheduleCalcId = this.responseId
        this.isScheduleCross = true
        this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
            .then((response) => {
                    this.showInfo(this.$t('shared.reportsSchedule.scheduleSaved') as string);
                    this.resetFiltersData();
                    this.needLoadFiltersForTable = true;

                    this.fetchScheduleCalcList();
                },
            )
            .catch((ex) => {
                this.showError(this.$t('shared.reportsSchedule.errorSaveCalcSchedule') as string);
            });
    }

    fetchScheduleCalcList() {
        const smallFilter = this.getSmallScheduleFilter();
        const offset = (this.pagination.current - 1) * this.scheduleCalcLimit;

        this.isTableLoading = true;

        this.httpGetSavedScheduleReports(smallFilter, this.scheduleCalcLimit, offset)
            .then((r) => {
                    this.scheduleListTableData = r.data.content;

                    this.scheduleListTableData.forEach((column, index) => {
                        column.key = column.id;
                        column.startDate = moment(new Date(column.startDate)).format('YYYY-MM-DD');
                        column.endDate = moment(new Date(column.endDate)).format('YYYY-MM-DD');
                    });

                    if (this.needLoadFiltersForTable) {
                        this.httpGetAllFiltersInScheduleReports(this.scheduleListTableData.map((it) => it.id))
                            .then((response) => {
                                    const result = response.data;

                                    this.tableFilterOptions.saleOptions = result.sales.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.groupOptions = result.groupsOfProduct.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.categoryOptions = result.categories.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.subcategoryOptions = result.subcategories.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.storeFormatOptions = result.storeFormat.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.storeRegionOptions = result.storeRegionValues.map((i) => ({value: i.id, label: i.name}));
                                    this.tableFilterOptions.storeClusterOptions = result.storeCluster.map((i) => ({value: i.id, label: i.name}));

                                    this.needLoadFiltersForTable = false;
                                },
                            )
                            .catch((ex) => {
                                this.showError(this.$t('shared.reportsSchedule.errorLoadTableFilters') as string);
                            });
                    }

                    this.pagination.total = r.data.totalElements;
                    this.scheduleCalcTotalRows = r.data.totalElements;
                },
            )
            .catch((e) => {
                this.showError(e);
            })
            .finally(() => {
                this.isTableLoading = false;
            });
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    private getCalcScheduleFilter(): ScheduleCalcFilter {
        const [selectRegions, selectFormats, selectClusters, categories, subcategory] = this.selectData();

        return {
            coefficientK1: this.parametersObj.selectCoefficent.value.k1,
            coefficientK2: this.parametersObj.selectCoefficent.value.k2,
            // tslint:disable-next-line: no-non-null-assertion
            categories,
            productSegments: [],
            storeCluster: selectClusters,
            seasonValues: [],
            buyerSegments: [],
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
            tradingId: this.$sales.selectMarket.id,
            calculationDay: +this.parametersObj.calculationDay,
            // tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: this.salePageSelected.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.parametersObj.selectCoefficent.value.enum!,
            subcategories: LocalData.filterNumberArrays([subcategory]),
            separateSubcategories: false,
            separateClusters: true,
            packageCalc: true,
            categoryStrategy: this.$sales.categoryStrategy.value,
            sendReportToFtp: this.parametersObj.sendReportToFtp,
            startDate: this.startScheduleDate,
            endDate: this.endScheduleDate,
            schedulePeriod: this.selectSchedulePeriod.value,
            priority: this.schedulePriority,
            timeout: this.scheduleTimeout,
            calcWithBatchNumber: true,
            backBasketPart: this.parametersObj.backBasketPart,
            compensateAllCategories: this.parametersObj.compensateAllCategories,
            thompsonSampling: this.parametersObj.thompsonSampling,
            revaluationCalculateParams: this.parametersObj.revaluationCalculateParams,
            applyOmnichannel: this.parametersObj.applyOmnichannel,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.parametersObj.isFixPricePromo,
            useSkuRotation: false,
            useFixedPrices: true,
            saleId: this.salePageSelected.id,
        };
    }

    private getSmallScheduleFilter(): SmallSalesReportsScheduleListFilter {
        return {
            tradingId: this.$sales.selectMarket.id,
            saleIds: this.tableFilterValues.sales.length ? this.tableFilterValues.sales : [], // TODO проверить
            startDate: this.tableFilterValues.startDate ? this.tableFilterValues.startDate : null, // TODO проверить
            endDate: this.tableFilterValues.endDate ? this.tableFilterValues.endDate : null, // TODO проверить
            categories: this.tableFilterValues.categories.length ? this.tableFilterValues.categories : [],
            groupsOfProduct: this.tableFilterValues.groups.length ? this.tableFilterValues.groups : [],
            subcategories: this.tableFilterValues.subcategories.length ? this.tableFilterValues.subcategories : [],
            storeFormat: this.tableFilterValues.storeFormat ? this.tableFilterValues.storeFormat : null,
            storeRegionValues: this.tableFilterValues.storeRegions.length ? this.tableFilterValues.storeRegions : [],
            storeClusters: this.tableFilterValues.storeClusters.length ? this.tableFilterValues.storeClusters : [],
        };
    }

    get isAdmin(): boolean {
        return this.$userRole === UserRole.ROLE_ADMIN;
    }

    private async fetchSalesForSelect() {
        this.isSalesForSelectLoading = true;

        return await this.api.fetchSales({
            tradingId: this.$sales.selectMarket.id,
            page: 0, // временно, для получения всех (облегчённых) распродаж без пагинации нужен отдельный api запрос
            size: 1000, // временно, для получения всех (облегчённых) распродаж без пагинации нужен отдельный api запрос
        })
            .then((resp) => {
                if (resp.status === 200) {
                    const array: ISaleOptionsForSelectBox[] = []
                    resp.data.content.forEach((e: ISaleResponseDto) => {
                        array.push({
                            value: e.id,
                            label: `#${e.id}: ${e.name}`,
                            groups: e.groups, // временно, после доработок по бэку убрать
                            categories: e.categories, // временно, после доработок по бэку убрать
                            subcategory: e.subcategory, // временно, после доработок по бэку убрать
                            format: e.format, // временно, после доработок по бэку убрать
                            regions: e.regions, // временно, после доработок по бэку убрать
                            clusters: e.clusters, // временно, после доработок по бэку убрать
                            minSaleDiscount: e.minSaleDiscount, // временно, после доработок по бэку убрать
                            maxSaleDiscount: e.maxSaleDiscount, // временно, после доработок по бэку убрать
                            status: e.status, // временно, после доработок по бэку убрать
                        })
                    })

                    this.selectSaleOptions = [...this.defaultSelectSaleOptions, ...array];

                    Promise.resolve();
                } else {
                    this.showError(this.$t('shared.reportsSchedule.errorLoadSalesForSelect') as string);
                }
            })
            .catch((error) => {
                this.showError(this.$t('shared.reportsSchedule.errorLoadSalesForSelect') as string);
            })
            .finally(() => {
                this.isSalesForSelectLoading = false;
            })
    }

    selectSearch(input: string, option: any) {
        return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    }

    handleSalePageSelectedChanged() {
        this.tableFilterValues = {
            sales: [],
            startDate: null,
            endDate: null,
            groups: [],
            categories: [],
            subcategories: [],
            storeFormat: null,
            storeRegions: [],
            storeClusters: [],
        };

        this.tableFilterOptions = {};
    }

    getFilteredCheckboxOptions(options: ILabelAndValue<number>[], searchable: boolean = false, text: string = ''): ILabelAndValue<number>[] {
        if (!searchable) {
            return options;
        } else {
            return options.filter(option => (text ? option.label.toLocaleLowerCase().includes(text.toLocaleLowerCase()) : true));
        }
    }
}
